export default __webpack_public_path__ + "static/media/ASSETS-Dashboard.4222e7d6.png";